import { connect } from 'react-redux'
import Form from './form'
import {
  createEmailIdentity,
  sendIdentityConnectEmail
} from '../redux/email-required.actions'
import {
  getEmailIdentityRequest,
  getEmailIdentityError,
  getSendIdentityConnectRequest
} from '../redux/email-required.selectors'
import { withMe } from 'pobble-components/dist/pobble-user'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { getErrorInfo } from 'pobble-components/dist/utils'

const ERRORS = {
  e0014: 'Sorry, this email is taken'
}

const mapStateToProps = (state, { meRequest, me, afterSingleSignOn }) => {
  const emailIdentityRequest = getEmailIdentityRequest(state)
  const sendIdentityConnectRequest = getSendIdentityConnectRequest(state)
  const errorRef = !afterSingleSignOn && getEmailIdentityError(state)
  return {
    error:
      errorRef && (ERRORS[getEmailIdentityError(state)] || 'Unknown error'),
    pending:
      emailIdentityRequest.pending ||
      meRequest.pending ||
      sendIdentityConnectRequest.pending
  }
}

const mapDispatchToProps = (dispatch, { refetchMe, afterSingleSignOn }) => ({
  onSubmit: values =>
    dispatch(
      createEmailIdentity({
        email: values.email
      })
    )
      .then(refetchMe)
      .catch(e => {
        if (getErrorInfo(e).ref !== 'e0014') return errorHandler(e)
        if (afterSingleSignOn) {
          dispatch(sendIdentityConnectEmail(values.email)).catch(errorHandler)
        }
      })
})

export default withMe(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Form)
)
